// Filter options - values match sourceType and NotificationStatus (English)
// Labels are in Spanish for display
export const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Todas' },
  { value: 'active', label: 'Pendiente' },
  { value: 'completed', label: 'Completada' },
] as const;

export const DEFAULT_STATUS_FILTER = 'active';

export const DATE_RANGE_PRESETS = [
  { value: 'all', label: 'Todo' },
  { value: 'today', label: 'Hoy' },
  { value: 'last7', label: 'Últimos 7 días' },
  { value: 'last30', label: 'Últimos 30 días' },
] as const;

// Bounded by default so the center opens on actionable work instead of the full history,
// which for long-lived users spans thousands of records. 'Todo' stays available in the selector.
export const DEFAULT_DATE_RANGE_PRESET = 'last30';

export const DOMAIN_TABS = [
  { value: 'all', label: 'Todas' },
  { value: 'alert', label: 'Alertas' },
  { value: 'event', label: 'Eventos' },
  { value: 'task', label: 'Tareas' },
  { value: 'question', label: 'Preguntas' },
] as const;

// Type definitions for filter values
export type DomainFilterValue = 'all' | 'task' | 'alert' | 'question' | 'event';
export type StatusFilterValue = 'all' | 'active' | 'completed' | 'archived';
export type DateRangePreset = (typeof DATE_RANGE_PRESETS)[number]['value'];

// Realtime listener limit
export const REALTIME_LISTENER_LIMIT = 50;

// Spanish month names
export const SPANISH_MONTHS = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SEPTIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE',
] as const;

// Pagination
export const NOTIFICATIONS_PAGE_SIZE = 20;

export const SEARCH_DEBOUNCE_MS = 300;
